import { render } from "./ContentDuplicate.vue?vue&type=template&id=7f76a90e"
import script from "./ContentDuplicate.vue?vue&type=script&lang=js"
export * from "./ContentDuplicate.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ContentDuplicate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f76a90e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f76a90e', __exports__)) {
    api.reload('7f76a90e', __exports__)
  }
  
  module.hot.accept("./ContentDuplicate.vue?vue&type=template&id=7f76a90e", () => {
    api.rerender('7f76a90e', render)
  })

}


export default __exports__